import type { EventData } from '@shared/types/events.types';
import {
  SAMPLE_EVENTS,
  CUSTOMER_EVENTS_DATA,
  TERMINAL_EVENTS_DATA,
  ECOMMERCE_EVENTS_DATA,
  PAYMENT_LINK_EVENTS_DATA,
  SAMPLE_INVOICE_EVENTS,
  SUBSCRIPTION_EVENTS_DATA,
  QUOTE_EVENTS_DATA,
  DISPUTE_EVENTS_DATA,
  REFUND_EVENTS_DATA,
  SAMPLE_PLAN_EVENTS,
} from '@shared/data';

export type EventsEntityType =
  | 'payment'
  | 'customer'
  | 'terminal'
  | 'ecommerce'
  | 'payment-link'
  | 'invoice'
  | 'subscription'
  | 'quote'
  | 'dispute'
  | 'refund'
  | 'inventory'
  | 'order'
  | 'plan'
  | 'product'
  | 'velocity-schedule'
  | 'fraud-rule'
  | 'fraud-rule-schedule'
  | 'fraud-list';

export interface EventsConfig {
  events: EventData[];
  useCustomerLayout?: boolean;
}

export const EVENTS_REGISTRY: Record<EventsEntityType, EventsConfig> = {
  payment:        { events: SAMPLE_EVENTS },
  customer:       { events: CUSTOMER_EVENTS_DATA, useCustomerLayout: true },
  terminal:       { events: TERMINAL_EVENTS_DATA },
  ecommerce:      { events: ECOMMERCE_EVENTS_DATA },
  'payment-link': { events: PAYMENT_LINK_EVENTS_DATA },
  invoice:        { events: SAMPLE_INVOICE_EVENTS },
  subscription:   { events: SUBSCRIPTION_EVENTS_DATA },
  quote:          { events: QUOTE_EVENTS_DATA },
  dispute:        { events: DISPUTE_EVENTS_DATA },
  refund:         { events: REFUND_EVENTS_DATA },
  inventory:      { events: SAMPLE_EVENTS },
  order:          { events: SAMPLE_EVENTS },
  plan:           { events: SAMPLE_PLAN_EVENTS },
  product:              { events: SAMPLE_EVENTS },
  'velocity-schedule':  { events: SAMPLE_EVENTS },
  'fraud-rule':         { events: SAMPLE_EVENTS },
  'fraud-rule-schedule': { events: SAMPLE_EVENTS },
  'fraud-list':         { events: SAMPLE_EVENTS },
};

export function getEventsConfig(entityType?: EventsEntityType): EventsConfig {
  if (!entityType) return { events: SAMPLE_EVENTS };
  return EVENTS_REGISTRY[entityType] ?? { events: SAMPLE_EVENTS };
}
